@if (displayText) {
  <div [id]="popupType" class="m-b-20"
    [ngClass]="{'success_created':(popupType==='success'), 'warning_alert':(popupType==='warning'), 'er-assign-warn': fromPage === 'erAssignUnassign'}">
    @if (popupType==='success') {
      <span class="material-icons done-color">done</span>
    }
    @if (popupType==='warning') {
      <span class="material-icons warning-color">error_outline</span>
    }
    <p>{{displayText}}</p>
    <a class="material-icons" (click)="sendMessage()">close</a>
  </div>
}